export const SCOPE = "modules/user/profile/";

export const UPDATE_PROFILE = SCOPE + "UPDATE_PROFILE";
export const UPDATE_AVATAR = SCOPE + "UPDATE_AVATAR";
export const UPDATE_RESUME = SCOPE + "UPDATE_RESUME";
export const CURRENT_RESUME = SCOPE + "CURRENT_RESUME";



// WEBPACK FOOTER //
// ./src/modules/user/profile/types.js